import {
  GET_NOTIFICATIONS_EMAIL,
  GET_NOTIFICATIONS_EMAIL_SUCCESS,
  GET_NOTIFICATIONS_EMAIL_FAIL,
  DELETE_NOTIFICATION_EMAIL,
  DELETE_NOTIFICATION_EMAIL_SUCCESS,
  DELETE_NOTIFICATION_EMAIL_FAIL,
  EDIT_NOTIFICATION_EMAIL,
  EDIT_NOTIFICATION_EMAIL_SUCCESS,
  EDIT_NOTIFICATION_EMAIL_FAIL,
  GET_AREA,
  GET_AREA_SUCCESS,
  GET_AREA_FAIL,
  SAVE_NOTIFICATION_EMAIL,
  SAVE_NOTIFICATION_EMAIL_SUCCESS,
  SAVE_NOTIFICATION_EMAIL_FAIL,
  CLEAN_NOTIFICATIONS_EMAIL,
  SEND_EMAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL
} from "./actionTypes"

export const getNotificationsEmail = filter => ({
  type: GET_NOTIFICATIONS_EMAIL,
  payload: filter,
})

export const getNotificationsEmailSuccess = notification => ({
  type: GET_NOTIFICATIONS_EMAIL_SUCCESS,
  payload: notification,
})

export const getNotificationsEmailFail = error => ({
  type: GET_NOTIFICATIONS_EMAIL_FAIL,
  payload: error,
})

export const deleteNotificationEmail = notification => ({
  type: DELETE_NOTIFICATION_EMAIL,
  payload: notification,
})

export const deleteNotificationEmailSuccess = notification => ({
  type: DELETE_NOTIFICATION_EMAIL_SUCCESS,
  payload: notification,
})

export const editNotificationEmail = notification => ({
  type: EDIT_NOTIFICATION_EMAIL,
  payload: notification,
})

export const deleteNotificationEmailFail = error => ({
  type: DELETE_NOTIFICATION_EMAIL_FAIL,
  payload: error,
})

export const editNotificationEmailSuccess = notification => ({
  type: EDIT_NOTIFICATION_EMAIL_SUCCESS,
  payload: notification,
})

export const editNotificationEmailFail = error => ({
  type: EDIT_NOTIFICATION_EMAIL_FAIL,
  payload: error,
})

export const getStatusOrder = () => ({
  type: GET_AREA,
  payload: "",
})

export const getStatusOrderSuccess = statusOrder => ({
  type: GET_AREA_SUCCESS,
  payload: statusOrder,
})

export const getStatusOrderFail = error => ({
  type: GET_AREA_FAIL,
  payload: error,
})

export const saveNotificationEmail = notification => ({
  type: SAVE_NOTIFICATION_EMAIL,
  payload: notification,
})

export const saveNotificationEmailSuccess = notification => ({
  type: SAVE_NOTIFICATION_EMAIL_SUCCESS,
  payload: notification,
})

export const saveNotificationEmailFail = error => ({
  type: SAVE_NOTIFICATION_EMAIL_FAIL,
  payload: error,
})

export const cleanNotificationEmail = () => {
  return {
    type: CLEAN_NOTIFICATIONS_EMAIL,
    payload: {},
  }
}

export const sendNotificationEmail = body => ({
  type: SEND_EMAIL,
  payload: body,
})

export const sendNotificationEmailSuccess = response => ({
  type: SEND_EMAIL_SUCCESS,
  payload: response,
})

export const sendNotificationEmailFail = error => ({
  type: SEND_EMAIL_FAIL,
  payload: error,
})